import React from "react";

import { red } from "@material-ui/core/colors";
//import { Button } from "@material-ui/core";
import AutoRotatingCarousel from "./AutoRotatingCarousel";
import Slide from "./Slide";
import { ViewPdf } from "./ViewPdf";

const validarPDF = (url) => {
  let result = url.search(".pdf");
  return result;
}

export const CarrouselCertificados = ({ mostrar, setMostrar, urls, titulo, idCertificado, esPreAfiliacion, idPreAfiliado }) => {

  return (
    <div>

      <AutoRotatingCarousel
        label="Get Info"
        open={mostrar}
        onClose={() => setMostrar(false)}
        onStart={() => setMostrar(false)}
        style={{ position: "absolute" }}
      >
        {
          urls.map((url, i) => (
            <Slide
              key={url.url}
              url={`${process.env.REACT_APP_URL}/${url.url}${url.nombreDocumento}`}
              titulo={titulo}
              idCertificado={idCertificado}
              idFileCertificado={url.idItem}
              esPreAfiliacion={esPreAfiliacion}
              idPreAfiliado={idPreAfiliado}
              subtitle={validarPDF(`${process.env.REACT_APP_URL}/${url.url}${url.nombreDocumento}`) === -1 ?`Imagen ${i + 1}` : `Documento ${i + 1}`}
              media={
                //MANDAMOS DIRECTAMENTE EL VIEWPDF YA QUE EN SLIDE SI ES PDF, VA A MOSTRAR LO QUE LE MANDAMOS ACA, PERO SI NO ES, VA A MOSTRAR LO QUE VA EN URL
                <ViewPdf url={`${process.env.REACT_APP_URL}/${url.url}${url.nombreDocumento}`} />
              }
              mediaBackgroundStyle={{ backgroundColor: red[400] }}
              style={{ backgroundColor: "#fff" }}
              delete={true}
            />
          ))
        }
      </AutoRotatingCarousel>
    </div>
  );
};
